<template>
  <v-col class="pa-6">
    <div v-if="!viewingRequest">
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            class="input ma-0 pa-0"
            label="Search..."
            prepend-inner-icon="mdi-magnify"
            v-model="search"
            rounded
            :hide-details="true"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-select
              style="max-width: 240px"
              class="input ma-0 pa-0"
              label="Status Type"
              v-model="selectedType"
              :items="statusTypes"
              rounded
              :hide-details="true"
              clearable
            ></v-select>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-data-table
          style="width: 100%"
          :headers="headers"
          :items="filteredRequests"
          :items-per-page="10"
          class="elevation-1 mt-4 ml-4 mr-8"
        >
          <template v-slot:item.action="{ item }">
            <td>
              <v-icon color="#4390c0" @click="viewRequest(item)"
                >mdi-eye</v-icon
              >
            </td>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              class="capatilize"
              :color="statusColor(item.status || 'pending')"
              dark
            >
              {{ item.status || "pending" }}
            </v-chip>
          </template>
        </v-data-table>
      </v-row>
    </div>
    <div v-if="viewingRequest">
      <v-row justify="center">
        <v-row class="ma-2">
          <v-col cols="12" md="6">
            <v-row class="mb-2">
              <v-icon class="black-color" @click="close()">
                mdi-arrow-left
              </v-icon>
              <h4 class="grey-color mx-4" style="font-weight: 500">
                Request Info
              </h4>
            </v-row>
          </v-col>
        </v-row>
      </v-row>
      <v-row justify="center">
        <div class="white-card pa-8">
          <v-row justify="start" class="ma-0">
            <h2 class="fs400 mb-4">Request Info</h2>
            <v-chip
              class="status-chip mx-2 mt-1"
              style="text-transform: capitalize"
              :color="statusColor(selectedRequest.status || 'Pending')"
              dark
            >
              {{ selectedRequest.status || "Pending" }}
            </v-chip>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-row justify="start">
                <v-col cols="12" md="6">
                  <v-row justify="start">
                    <p><strong>Name:</strong></p>
                  </v-row>
                  <v-row justify="start">
                    <v-text-field
                      readonly
                      filled
                      outlined
                      dense
                      rounded
                      v-model="selectedRequest.name"
                    >
                    </v-text-field>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col cols="12" md="6">
                  <v-row justify="start">
                    <p><strong>Surname:</strong></p>
                  </v-row>
                  <v-row justify="start">
                    <v-text-field
                      readonly
                      filled
                      outlined
                      dense
                      rounded
                      v-model="selectedRequest.surname"
                    >
                    </v-text-field>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col cols="12" md="6">
                  <v-row justify="start">
                    <p><strong>ID Number:</strong></p>
                  </v-row>
                  <v-row justify="start">
                    <v-text-field
                      readonly
                      filled
                      outlined
                      dense
                      rounded
                      v-model="selectedRequest.idNumber"
                    >
                    </v-text-field>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col cols="12" md="6">
                  <v-row justify="start">
                    <p><strong>Phone Number:</strong></p>
                  </v-row>
                  <v-row justify="start">
                    <v-text-field
                      readonly
                      filled
                      outlined
                      dense
                      rounded
                      v-model="selectedRequest.CellNo"
                    >
                    </v-text-field>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col cols="12" md="6">
                  <v-row justify="start">
                    <p><strong>Email Address:</strong></p>
                  </v-row>
                  <v-row justify="start">
                    <v-text-field
                      readonly
                      filled
                      outlined
                      dense
                      rounded
                      v-model="selectedRequest.email"
                    >
                    </v-text-field>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col cols="12" md="6">
                  <v-row justify="start">
                    <p><strong>Address:</strong></p>
                  </v-row>
                  <v-row justify="start">
                    <v-textarea
                      readonly
                      filled
                      outlined
                      dense
                      rounded
                      v-model="selectedRequest.address.placeName"
                    >
                    </v-textarea>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="6">
              <v-row justify="center" justify-md="start">
                <p><strong>Request Status:</strong></p>
              </v-row>
              <v-row justify="center" justify-md="start">
                <v-select
                  style="max-width: 240px"
                  class="ma-0 pa-0"
                  v-model="selectedRequest.status"
                  :items="statusTypes"
                  dense
                  filled
                  outlined
                  rounded
                  :hide-details="true"
                ></v-select>
              </v-row>
              <v-row justify="center" justify-md="start">
                <v-btn
                  @click="updateStatus()"
                  color="#e022d1"
                  dark
                  rounded
                  width="240px"
                  class="pink-btn mt-4"
                >
                  Update Status
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-row>
    </div>
    <!-- Loading Overlay -->
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular :size="100" color="#4390c0" indeterminate />
      </v-overlay>
    </v-row>
    <v-dialog v-model="promptDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="red" v-if="promptType == 'error'">
            mdi-alert-circle
          </v-icon>
          <v-icon size="96" color="green" v-if="promptType == 'success'">
            mdi-check-circle
          </v-icon>
          <div class="text-h5 my-6" v-if="promptType == 'error'">Error</div>
          <div class="text-h5 my-6" v-if="promptType == 'success'">Success</div>
          <div class="body-1 text-h6">{{ promptMessage }}</div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            color="black"
            dark
            depressed
            large
            style="border-radius: 24px"
            @click="promptDialog = false"
          >
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import {
  collection,
  getDocs,
  where,
  getFirestore,
  setDoc,
  query,
  getDoc,
  onSnapshot,
  doc,
  addDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

import { logAction } from "@/utils/firestoreUtil";

export default {
  data() {
    return {
      headers: [
        { text: "Name", value: "name" },
        {
          text: "Surname",
          value: "surname",
        },
        { text: "ID Number", value: "idNumber" },
        { text: "Phone Number", value: "CellNo" },
        { text: "Email", value: "email" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" },
      ],
      search: "",
      statusTypes: ["pending", "completed"],
      selectedType: null,
      requests: [],
      selectedRequest: null,
      viewingRequest: false,
      loading: false,
      promptDialog: false,
      promptMessage: "",
      promptType: "",
      unsubscribeRequests: null,
    };
  },
  methods: {
    close() {
      this.viewingRequest = false;
      localStorage.removeItem("ViewedRequest");
    },
    viewRequest(item) {
      this.selectedRequest = item;
      this.viewingRequest = true;
      localStorage.setItem(
        "ViewedRequest",
        JSON.stringify(this.selectedRequest)
      );
    },
    async getRequests() {
      try {
        const q = query(collection(db, "clearanceRequests"));

        this.loading = true;

        // Subscribe to real-time updates
        this.unsubscribeRequests = onSnapshot(q, (querySnapshot) => {
          this.requests = [];

          querySnapshot.forEach((doc) => {
            let tempRequest = doc.data();
            tempRequest.id = doc.id;
            this.requests.push(tempRequest);
          });

          this.loading = false;
        });
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
      }
    },
    statusColor(status) {
      switch (status) {
        case "denied":
          return "#e022d1";
        case "pending":
          return "#4390c0";
        case "completed":
          return "green";
        default:
          return "grey";
      }
    },
    async updateStatus() {
      try {
        this.loading = true;
        let docRef = await setDoc(
          doc(db, "clearanceRequests", this.selectedRequest.id),
          this.selectedRequest
        );
        this.loading = false;

        let res = await this.logStatusUpdate();

        this.promptMessage = "Successfully updated request status!";
        this.promptType = "success";
        this.promptDialog = true;

        setTimeout(() => {
          this.promptDialog = false;
        }, 3000);
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
        this.promptMessage =
          "An error occured while updating the request's status, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async logStatusUpdate() {
      let res = await logAction(
        "Clearance Request Management",
        "Status Update",
        this.loggedInUser.email,
        this.loggedInUser.email +
          " has updated the status of request " +
          this.selectedRequest.id +
          " to " +
          this.selectedRequest.status
      );
    },
  },
  async created() {
    let res = await this.getRequests();

    if (localStorage.getItem("ViewedRequest")) {
      let selectedRequest = JSON.parse(localStorage.getItem("ViewedRequest"));
      let newRequest = this.requests.find(
        (request) => request.id == selectedRequest.id
      );

      if (newRequest) {
        this.selectedRequest = newRequest;
        this.viewingRequest = true;
      }
    }
  },
  computed: {
    filteredRequests() {
      return this.requests.filter((item) => {
        // Filter by status if selectedStatus is not null
        const matchesStatus =
          this.selectedType === null || item.status === this.selectedType;

        // Filter by search text
        const matchesSearch = Object.values(item).some((value) => {
          if (value !== null && value !== undefined) {
            return value
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase());
          }
          return false;
        });

        // Only return items that match both filters
        return matchesStatus && matchesSearch;
      });
    },
    loggedInUser() {
      return this.$store.state.user || {};
    },
  },
  beforeUnmount() {
    if (this.unsubscribeRequests) {
      this.unsubscribeRequests();
    }
  },
};
</script>

<style scoped></style>
